import { createLogger } from "../../utils/logger"

const logger = createLogger('advance-storage')

// Clave por archivo (nombre + tamaño) — no es a prueba de colisiones pero
// alcanza para esta fase sin backend. Si el usuario sube otro DXF con mismo
// nombre y tamaño, hidratará el avance previo; suficiente para demo.
const ADVANCE_STORAGE_PREFIX = 'epc.layout-builder.advance.v1.'

/**
 * Persistencia del avance lineal en localStorage (cache rápido por archivo).
 * Lógica aislada de la presentación: recibe el `file` y el `state`, no toca
 * la escena ni el componente. El backend sigue siendo la fuente canónica.
 */

/**
 * @param {?{name:string, size?:number}} file
 * @returns {?string} clave de storage, o null si no hay archivo.
 */
export function advanceStorageKey(file) {
  if (!file || !file.name) return null
  return ADVANCE_STORAGE_PREFIX + file.name + ':' + (file.size || 0)
}

/**
 * Lee el estado de avance guardado para el archivo. Devuelve {} si no hay o falla.
 * @param {?{name:string, size?:number}} file
 * @returns {Object}
 */
export function loadAdvanceState(file) {
  const key = advanceStorageKey(file)
  if (!key) return {}
  try {
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    logger.warn('No se pudo leer avance del localStorage:', e)
    return {}
  }
}

/**
 * Persiste el estado de avance del archivo. Si queda vacío, remueve la entrada
 * en lugar de guardar "{}".
 * @param {?{name:string, size?:number}} file
 * @param {Object} state
 */
export function persistAdvanceState(file, state) {
  const key = advanceStorageKey(file)
  if (!key) return
  try {
    if (!state || Object.keys(state).length === 0) {
      localStorage.removeItem(key)
    } else {
      localStorage.setItem(key, JSON.stringify(state))
    }
  } catch (e) {
    logger.warn('No se pudo persistir avance:', e)
  }
}
